import { Component, OnInit, Input } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ForAllService } from "../for-all.service";
import {TranslateService} from '@ngx-translate/core';
import { MatSnackBar } from "@angular/material/snack-bar";
import * as $ from 'jquery';
import Swal from 'sweetalert2';

@Component({
  selector: 'traducciones',
  templateUrl: './traducciones.component.html',
  styleUrls: ['./traducciones.component.scss']
})
export class TraduccionesComponent implements OnInit {

  comunicacionPracticas: any;
  @Input() actualizaTraducciones: Observable<any>;
  comunicacionPaso: any;
  @Input() statusPaso: Observable<any>;

  cargando = true;
  guardando: boolean;
  pasoCompleto: boolean;

  practicas: any;
  idiomas: any;
  traducciones: any;
  traduccionesOriginal: any;

  constructor(
    private forallService: ForAllService,
    private translate: TranslateService,
    private snackBar: MatSnackBar,
  ) { }

  ngOnInit() {
    this.comunicacionPracticas = this.actualizaTraducciones.subscribe( (datos) => {
      if(datos){
        console.log("se envio datos desde componente correos: ",datos);
        this.cargando = true;
        this.getPracticas();
      }
    });
    this.comunicacionPaso = this.statusPaso.subscribe( (datos) => {
      if(datos != null){
        console.log("se envio datos desde componente base: ",datos);
        this.pasoCompleto = datos;
      }
    });
  }

  getPracticas(){
    let data = {"fechaCertificar": localStorage.getItem('fechaProducto')};

    this.forallService.getPracticas(data).subscribe((respuesta:any) => {
      console.log("getPracticasTraducciones:",respuesta);
      if(respuesta.message == 200){
        this.practicas = respuesta.practicas;
        this.getIdiomasEncuesta();
      }
    }, error => {
      console.log("error", error);
    });
  }

  getIdiomasEncuesta(){
    let data = {
      fechaCertificar:localStorage.getItem('fechaProducto')
    };
    this.traducciones = [];
    this.forallService.getIdiomasEncuesta(data).subscribe((respuesta:any) => {
      console.log("Get idiomas");
      this.cargando = false;
      console.log("getIdiomasEncuesta:",respuesta);
      this.idiomas = respuesta.idiomasMostrar;
      this.idiomas.forEach((idioma,i) => {
        let traduccionesIdioma: any[] = [];
        this.practicas.forEach((practica,j) => {
          let datos: any = {
            idPractica: practica._id,
            practNativo: practica.practicaForall,
            descNativo: practica.descripcionForall,
            lenguaje: idioma.nombreIdioma,
            id: idioma._id,
            practice: '',
            description: ''
          };
          let indiceIdioma = practica.traducciones.findIndex(item => item.idioma == idioma._id);
          if(indiceIdioma != -1){
            if(practica.traducciones[indiceIdioma].practicaForall){
              datos.practice = practica.traducciones[indiceIdioma].practicaForall;
            }
            if(practica.traducciones[indiceIdioma].descripcionForall){
              datos.description = practica.traducciones[indiceIdioma].descripcionForall;
            }
          }
          traduccionesIdioma.push(datos);
        });
        let datosTraduccion: any = {
          nombreIdioma: idioma.nombreIdioma,
          tipoIdioma: idioma.tipoIdioma,
          vivoIdioma: idioma.vivoIdioma,
          _id: idioma._id,
          arreglo: traduccionesIdioma
        };
        this.traducciones.push(datosTraduccion);
      });
      this.traduccionesOriginal = JSON.parse(JSON.stringify(this.traducciones));
      
    }, error => {
      console.log("error", error);
    })
  }

  guardaPractica(event:any, posIdioma:number, posicion:number, idForall:string, idiomaId:string){
    if(!this.guardando){
      if(event.target.value.length >= 1){
        console.log("textoDS:",this.traduccionesOriginal[posIdioma].arreglo[posicion].practice," textoTaget:",event.target.value);
        if(this.traduccionesOriginal[posIdioma].arreglo[posicion].practice != event.target.value)
        {
          this.guardando = true;
          $(document).ready(function(){ $(':focus').blur(); });
          this.modalGuardado(1);
          let data = {
            fechaCertificar: localStorage.getItem('fechaProducto'),
            idForall,
            practicaForall:  event.target.value,
            idiomaId
          };
          console.log("datosAEnviarPrac:",data);
          this.forallService.guardaTraduccion(data).subscribe((respuesta:any) => {
            if(respuesta.message.includes('Success')){
              this.openSuccessSnackBar(this.translate.instant('CERTIFICAR.FORALL.MSJ_TRANSLATEREGISTERED'),this.translate.instant('ALERTS.OK'));
              Swal.close();
              this.traduccionesOriginal[posIdioma].arreglo[posicion].practice = data.practicaForall;
              this.guardando = false;
            }
          }, error => {
            console.log(error);
          });
        }
        else console.log("es el mismo texto nomms :v");

      }
    }
  }

  guardaDescripcion(event:any, posIdioma:number, posicion:number, idForall:string, idiomaId:string){
    if(!this.guardando){
      if(event.target.value.length >= 1){
        console.log("textoDS:",this.traduccionesOriginal[posIdioma].arreglo[posicion].description," textoTaget:",event.target.value);
        if(this.traduccionesOriginal[posIdioma].arreglo[posicion].description != event.target.value)
        {
          this.guardando = true;
          $(document).ready(function(){ $(':focus').blur(); });
          this.modalGuardado(2);
          let data = {
            fechaCertificar: localStorage.getItem('fechaProducto'),
            idForall,
            descripcionForall: event.target.value,
            idiomaId
          };
          console.log("datosAEnviarDesc:",data);
          this.forallService.guardaTraduccion(data).subscribe((respuesta:any) => {
            if(respuesta.message.includes('Success')){
              this.openSuccessSnackBar(this.translate.instant('CERTIFICAR.FORALL.MSJ_DESCRIPTIONTRANSLATED'),this.translate.instant('ALERTS.OK'));
              Swal.close();
              this.traduccionesOriginal[posIdioma].arreglo[posicion].description = data.descripcionForall;
              this.guardando = false;
            }
          }, error => {
            console.log(error);
          });
        }
        else console.log("es el mismo texto nomms :v");
      }
    }
  }

  modalGuardado(opcion:number){
    let mensaje: string;
    switch (opcion) {
      case 1:
        this.translate.get('CERTIFICAR.FORALL.CARGANDO_PRACTICA').subscribe((res: string) => { mensaje = res; });
      break;
      case 2:
        this.translate.get('CERTIFICAR.FORALL.CARGANDO_DESCRIPCION').subscribe((res: string) => { mensaje = res; });
      break;
    }
    Swal.fire({
      title: mensaje,
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading()
      }
    });
  }

  openSuccessSnackBar(message: string, action: string) {
     this.snackBar.open(message, action, {
        duration: 5000,
        panelClass: ['background-success']
     });
  }

}
